export const iconFontAwesomeChildhoodChildReaching = (
	<i className="fa-solid fa-child-reaching"></i>
);
